import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_visibility/_standalone")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
